/* eslint-disable no-restricted-globals */
/* eslint-disable */

import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";

import DialogCommon from "components/dialogCommon";
import { DadosComplementares } from "components/dialogCommon/templates/dadosComplementares";
import { PreferenciasDoLead } from "components/dialogCommon/templates/preferenciasDoLead";
import { useDadosBasicosV2 } from "services/api/AppWeb_Lead/dados-basicos";
import { Skeleton } from "@mui/material";
import LeadPhonesModal from "components/dialogCommon/templates/LeadPhonesModal";
import LeadEmailModal from "components/dialogCommon/templates/LeadEmailModal";
import LeadOfertaModal from "components/dialogCommon/templates/LeadOfertaModal";
import Socket from "../../hooks/socket";
import { DadosBasicosHeader } from "./DadosBasicosHeader";
import * as Styles from "./styles";
import { IdentificacaoLead } from "./IdentificacaoLead";
import { ProdutosInteresse } from "./ProdutosInteresse";
import * as IconsSVG from "../../assets/iconsSVG";
import TabSection from "./TabSection";
import { HistoricoSection } from "./TabSection/components/HistoricoSection";
import NavCommon from "../../components/@navHeader";
import { Stepper } from "./Stepper";
import NameForm from "../../components/dialogCommon/templates/nameForm";
import NewTaskV2 from "../../components/dialogCommon/templates/NewTaskV2";
import EditTaskV2 from "../../components/dialogCommon/templates/EditTaskV2";
import ConcludeTaskV2 from "../../components/dialogCommon/templates/ConcludeTaskV2";
import ShareForm from "../../components/dialogCommon/templates/shareForm";
import { RootStateOrAny, useSelector } from "react-redux";
import { AuthState } from "store/ducks/auth/types";
import { IoIosRefresh, IoMdUndo } from "react-icons/io";
import { EtapasModalWarning } from "components/dialogCommon/templates/etapasModalWarning";
import LeadOrigemModal from "components/dialogCommon/templates/LeadOrigemModal";
import AtualizarLeadModal from "../../components/AtualizarLeadModal";
import EnviarWhatsAppModal from "../../components/EnviarWhatsAppModal";

interface Lead {
  idLead: string;
  idLeadCorretor: string;
  nomeCorretorLead: string;
  nomeCorretorOrigem: string;
  urlFotoUsuarioCorretor: string;
  urlFotoUsuarioCorretorOrigemLead: string;
  etapaFunil: string;
}

export function LeadDetail() {
  Socket();
  const history = useHistory();
  const params: Lead = useParams();
  const {
    data: dataLead,
    refetch: refetchDataLead,
    isLoading: isLoadingDataLead,
  } = useDadosBasicosV2({
    idLeadCorretor: params?.idLeadCorretor,
    queryKey: "dados-basicos-lead-detail",
  });
  const { codigoCargo2013, usuarioGerenteOnline } = useSelector<
    RootStateOrAny,
    AuthState
  >((state) => state.user);

  React.useEffect(() => {
    if (params?.idLeadCorretor) {
      refetchDataLead();
    }
  }, [params?.idLeadCorretor]);

  const [modalPhone, setModalPhone] = React.useState<boolean>(false);
  const [modalEmail, setModalEmail] = React.useState<boolean>(false);
  const [modalName, setModalName] = React.useState<boolean>(false);
  const [modalNewTask, setModalNewTask] = React.useState<boolean>(false);
  const [modalEditTask, setModalEditTask] = React.useState<boolean>(false);
  const [modalConcludeTask, setModalConcludeTask] =
    React.useState<boolean>(false);
  const [modalShare, setModalShare] = React.useState<boolean>(false);
  const [modalAtualizarLead, setModalAtualizarLead] =
    React.useState<boolean>(false);
  const [modalWhatsApp, setModalWhatsApp] = React.useState<boolean>(false);
  const [whatsAppPhone, setWhatsAppPhone] = React.useState<string>("");
  const [taskSelected, setTaskSelected] = React.useState<any>(null);
  const [modalOfertas, setModalOfertas] = React.useState<boolean>(false);
  const [modalOrigem, setModalOrigem] = React.useState<boolean>(false);
  const [dadosComplementares, setDadosComplementares] =
    React.useState<boolean>(false);
  const [preferenciasDoLead, setPreferenciasDoLead] =
    React.useState<boolean>(false);
  const [etapasOpen, setEtapasOpen] = useState(false);
  const [anchorEtapa, setAnchorEtapa] = useState({ label: "", value: "" });
  const [anchorSubEtapa, setAnchorSubEtapa] = useState({
    label: "",
    value: "",
  });
  const anchorLeadCorretor = dataLead?.idLeadCorretor
    ? dataLead?.idLeadCorretor
    : null;

  useEffect(() => {
    if (
      !usuarioGerenteOnline &&
      ((dataLead?.subEtapaLead === null && codigoCargo2013 === "219.840.002") ||
        (dataLead?.subEtapaLead === null && codigoCargo2013 === "219.840.012") ||
        (dataLead?.subEtapaLead === null && codigoCargo2013 === "219.840.001"))
    ) {
      setEtapasOpen(true);
      setAnchorEtapa({
        label: dataLead?.etapaLead || "",
        value: dataLead?.idEtapaLead || "",
      });
      setAnchorSubEtapa({
        label: dataLead?.subEtapaLead || "",
        value: dataLead?.idSubEtapaLead || "",
      });
    }
  }, [dataLead]);

  return (
    <>
      <NavCommon
        breadcrumbs={[
          { path: "/leads", name: `Carteira` },
          {
            path: "",
            name: "Detalhes do lead",
          },
        ]}
        showButtonNew
        onBack={() => {
          history.push({ pathname: "/leads" });
          localStorage.setItem("@sell.it/previousScreen", window.location.href);
        }}
        open
        onChangeActionNew={undefined}
      />
      <Styles.Container>
        <Styles.MainContent>
          <Stepper
            dataLead={dataLead}
            refetch={() => refetchDataLead()}
            readOnly={usuarioGerenteOnline}
          />
          <DadosBasicosHeader
            openModalPhones={() => !usuarioGerenteOnline && setModalPhone(true)}
            openModalEmails={() => !usuarioGerenteOnline && setModalEmail(true)}
            openModalOfertas={() => setModalOfertas(true)}
            openModalOrigem={() => setModalOrigem(true)}
            openModalDadosComplementares={() => setDadosComplementares(true)}
            openModalName={() => !usuarioGerenteOnline && setModalName(true)}
            openWhatsAppModal={(phone) => {
              setWhatsAppPhone(phone);
              setModalWhatsApp(true);
            }}
            onUpdateClick={() =>
              !usuarioGerenteOnline && setModalAtualizarLead(true)
            }
            dataLead={dataLead}
            refetch={() => refetchDataLead()}
            readOnly={usuarioGerenteOnline}
          />
          <IdentificacaoLead
            visaoCorretor={
              !usuarioGerenteOnline &&
              (codigoCargo2013 === "219.840.002" ||
                codigoCargo2013 === "219.840.012" ||
                codigoCargo2013 === "219.840.001")
            }
            idLead={dataLead?.idLead}
            idLeadCorretor={dataLead?.idLeadCorretor}
            observacaoCliente={dataLead?.observacaoCliente}
            isLoading={isLoadingDataLead}
          />
          <ProdutosInteresse
            produtosInteresse={dataLead?.produtosInteresse}
            openModalDadosComplementares={() => setPreferenciasDoLead(true)}
            dataLead={dataLead}
            readOnly={usuarioGerenteOnline}
          />
          {dataLead ? (
            <>
              <TabSection
                dataLead={dataLead}
                idLead={dataLead?.idLead}
                idLeadCorretor={dataLead?.idLeadCorretor}
                idCorretorLead={dataLead?.idCorretorLead}
                onOpenNewTask={() => setModalNewTask(true)}
                avoidRefetch={
                  modalEditTask || modalConcludeTask || modalNewTask
                }
                onOpenEditTask={(val) => {
                  setModalEditTask(true);
                  setTaskSelected(val);
                }}
                onOpenConcludeTask={(val) => {
                  setModalConcludeTask(true);
                  setTaskSelected(val);
                }}
                refetchDataLead={() => refetchDataLead()}
                onOpenShare={() => setModalShare(true)}
                readOnly={usuarioGerenteOnline}
              />
            </>
          ) : (
            <>
              <Skeleton
                variant="rounded"
                width="100%"
                style={{ marginTop: 16 }}
                height="15rem"
              />
            </>
          )}
        </Styles.MainContent>
        <Styles.HistoricoPanelPlaceholder />
        <Styles.HistoricoPanel>
          <h3>Histórico</h3>
          <HistoricoSection idLeadCorretor={dataLead?.idLeadCorretor} />
        </Styles.HistoricoPanel>
      </Styles.Container>

      <DialogCommon
        closeText="Fechar"
        saveText="Salvar"
        onClose={() => setPreferenciasDoLead}
        onSave={() => {
          refetchDataLead();
        }}
        isRight={false}
        onClean={() => {}}
        title="Preferências"
        isFilter={false}
        isClose
        width={800}
        height={650}
        component={
          <>
            <PreferenciasDoLead
              idLeadCorretor={params?.idLeadCorretor}
              closeModal={() => setPreferenciasDoLead(false)}
              refetchDataLead={() => refetchDataLead()}
              readOnly={usuarioGerenteOnline}
            />
          </>
        }
        setOpenModal={setPreferenciasDoLead}
        open={preferenciasDoLead}
        icon={<IconsSVG.PreferenciasIcon />}
      />
      <DialogCommon
        closeText="Fechar"
        saveText="Salvar"
        onClose={() => setModalPhone}
        onSave={() => {}}
        isRight={false}
        onClean={() => {}}
        title="Telefone"
        isFilter={false}
        isClose
        width={400}
        height={580}
        component={
          <LeadPhonesModal
            closeModal={() => {
              setModalPhone(false);
              refetchDataLead();
              location.reload();
            }}
            idLead={dataLead?.idLead}
            idLeadCorretor={dataLead?.idLeadCorretor}
            phone1={dataLead?.telefone1 || ""}
            phone2={dataLead?.telefone2 || ""}
            phone3={dataLead?.telefone3 || ""}
            phonePrincipal={dataLead?.codigoTelefonePrincipal}
            telefoneOrigemInformado={dataLead?.telefoneOrigemInformado}
          />
        }
        setOpenModal={setModalPhone}
        open={modalPhone}
        icon={<IconsSVG.PhoneIcon />}
      />
      <DialogCommon
        closeText="Fechar"
        saveText="Salvar"
        onClose={() => setModalEmail}
        onSave={() => {}}
        isRight={false}
        onClean={() => {}}
        title="Email"
        isFilter={false}
        isClose
        width={400}
        height={580}
        component={
          <LeadEmailModal
            closeModal={() => {
              setModalPhone(false);
              refetchDataLead();
              location.reload();
            }}
            idLead={dataLead?.idLead}
            idLeadCorretor={dataLead?.idLeadCorretor}
            email1={dataLead?.email1 || ""}
            email2={dataLead?.email2 || ""}
            email3={dataLead?.email3 || ""}
            emailPrincipal={dataLead?.codigoEmailPrincipal}
            emailOrigemInformado={dataLead?.emailOrigemInformado}
          />
        }
        setOpenModal={setModalEmail}
        open={modalEmail}
        icon={<IconsSVG.MailIcon />}
      />
      <DialogCommon
        closeText="Fechar"
        saveText="Salvar"
        onClose={() => setModalOfertas}
        onSave={() => {}}
        isRight={false}
        onClean={() => {}}
        title="Oferta Ativa"
        isFilter={false}
        isClose
        width={650}
        borderRadius={12}
        component={
          <LeadOfertaModal
            closeModal={() => setModalOfertas(false)}
            idLead={dataLead?.idLead}
            idLeadCorretor={dataLead?.idLeadCorretor}
          />
        }
        setOpenModal={setModalOfertas}
        open={modalOfertas}
        icon={
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "#EAEFFF",
              border: "8px solid #F3F6FF",
              padding: 2,
              borderRadius: "50%",
              height: 52,
              width: 52,
            }}
          >
            <IconsSVG.SpeakerIcon
              color="#2D5BFF"
              width={18}
              height={18}
              style={{ margin: 0 }}
            />
          </div>
        }
      />
      <DialogCommon
        closeText="Fechar"
        saveText="Salvar"
        onClose={() => setModalOrigem}
        onSave={() => {}}
        isRight={false}
        onClean={() => {}}
        title="Origens"
        isFilter={false}
        isClose
        width={800}
        borderRadius={12}
        component={
          <LeadOrigemModal
            closeModal={() => setModalOrigem(false)}
            idLead={dataLead?.idLead}
            idLeadCorretor={dataLead?.idLeadCorretor}
          />
        }
        setOpenModal={setModalOrigem}
        open={modalOrigem}
        icon={
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "#D1FADF",
              border: "8px solid #ECFDF3",
              padding: 2,
              borderRadius: "50%",
              height: 52,
              width: 52,
              marginRight: 12,
            }}
          >
            <IoMdUndo
              color="black"
              size={24}
              style={{
                margin: 0,
                transform: "scaleX(-1)",
              }}
            />
          </div>
        }
      />
      <DialogCommon
        closeText="Fechar"
        saveText="Salvar"
        onClose={() => setModalName}
        onSave={() => {}}
        isRight={false}
        onClean={() => {}}
        title="Alterar nome"
        isFilter={false}
        isClose
        width={400}
        height={350}
        component={
          <NameForm
            idLead={dataLead?.idLead}
            idLeadCorretor={dataLead?.idLeadCorretor}
            nomeLead={dataLead?.nomeLead}
            closeModal={() => {
              setModalName(false);
              refetchDataLead();
            }}
          />
        }
        setOpenModal={setModalName}
        open={modalName}
        icon={<IconsSVG.EditUserIcon />}
      />
      <DialogCommon
        closeText="Fechar"
        saveText="Salvar"
        onClose={() => setModalNewTask}
        onSave={() => {}}
        isRight={false}
        onClean={() => {}}
        title="Agendar tarefa"
        isFilter={false}
        isClose
        width={712}
        height={620}
        maxHeight="680px"
        component={
          <NewTaskV2
            idLead={dataLead?.idLead}
            idLeadCorretor={dataLead?.idLeadCorretor}
            dataLead={dataLead}
            lead={{
              idLeadCorretor: dataLead?.idLeadCorretor,
              nomeLead: dataLead?.nomeLead,
            }}
            closeModal={() => {
              setModalNewTask(false);
            }}
            refetchDataLead={() => refetchDataLead()}
            refetch={() => refetchDataLead()}
          />
        }
        setOpenModal={setModalNewTask}
        open={modalNewTask}
        icon={<IconsSVG.NewTaskDialog />}
      />
      <DialogCommon
        closeText="Fechar"
        saveText="Salvar"
        onClose={() => setModalEditTask}
        onSave={() => {}}
        isRight={false}
        onClean={() => {}}
        title="Editar tarefa"
        isFilter={false}
        isClose
        width={712}
        height={620}
        component={
          <EditTaskV2
            idLead={dataLead?.idLead}
            idLeadCorretor={dataLead?.idLeadCorretor}
            dataTask={taskSelected}
            closeModal={() => {
              setModalEditTask(false);
            }}
            refetch={() => refetchDataLead()}
          />
        }
        setOpenModal={setModalEditTask}
        open={modalEditTask}
        icon={<IconsSVG.NewTaskDialog />}
      />
      <DialogCommon
        closeText="Fechar"
        saveText="Salvar"
        onClose={() => setModalConcludeTask}
        onSave={() => {}}
        isRight={false}
        onClean={() => {}}
        title="Concluir tarefa"
        isFilter={false}
        isClose
        width={712}
        height={620}
        component={
          <ConcludeTaskV2
            idLead={dataLead?.idLead}
            idLeadCorretor={dataLead?.idLeadCorretor}
            dataTask={taskSelected}
            dataLead={dataLead}
            closeModal={() => {
              setModalConcludeTask(false);
            }}
            refetch={() => refetchDataLead()}
            refetchDataLead={() => refetchDataLead()}
          />
        }
        setOpenModal={setModalConcludeTask}
        open={modalConcludeTask}
        icon={<IconsSVG.NewTaskDialog />}
      />
      <DialogCommon
        closeText="Fechar"
        saveText="Salvar"
        onClose={() => setModalShare(false)}
        onSave={() => {}}
        isRight={false}
        onClean={() => {}}
        title="Compartilhar Lead"
        isFilter={false}
        isClose
        width={400}
        height={360}
        component={
          <ShareForm
            idLead={dataLead?.idLead}
            idLeadCorretor={dataLead?.idLeadCorretor}
            hotRefreshFunc={() => refetchDataLead()}
            onClose={() => setModalShare(false)}
            open={modalShare}
          />
        }
        setOpenModal={setModalShare}
        open={modalShare}
        icon={<IconsSVG.NewTaskDialog />}
      />
      <DialogCommon
        closeText="Fechar"
        saveText="Salvar"
        onClose={() => setEtapasOpen(false)}
        onSave={() => {}}
        isRight={false}
        onClean={() => {}}
        titleHeader="Atualizar etapa"
        title="Atualize a Subetapa para prosseguir"
        isFilter={false}
        isLogin
        isClose
        blockClose
        width={400}
        component={
          <EtapasModalWarning
            onClose={() => setEtapasOpen(false)}
            open={etapasOpen}
            anchorLeadCorretor={anchorLeadCorretor}
            anchorEtapa={anchorEtapa}
            anchorSubEtapa={anchorSubEtapa}
            refetch={() => refetchDataLead()}
          />
        }
        setOpenModal={setEtapasOpen}
        open={etapasOpen}
        icon={
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "#D1FADF",
              border: "8px solid #ECFDF3",
              padding: 2,
              borderRadius: "50%",
              height: 52,
              width: 52,
              marginRight: 12,
            }}
          >
            <IoIosRefresh color="black" size={24} style={{ margin: 0 }} />
          </div>
        }
      />
      <AtualizarLeadModal
        open={modalAtualizarLead}
        onClose={() => setModalAtualizarLead(false)}
        idLead365={dataLead?.idLead || ""}
        onSuccess={() => refetchDataLead()}
      />

      <EnviarWhatsAppModal
        open={modalWhatsApp}
        onClose={() => setModalWhatsApp(false)}
        leadName={dataLead?.nomeLead || ""}
        leadPhone={whatsAppPhone || ""}
        idLeadCorretor365={dataLead?.idLeadCorretor || params?.idLeadCorretor}
      />
    </>
  );
}
